import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { useParams, Link, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Vehicle_Transferring_history = () => {
  useAuthRedirect();
  const { id, branch } = useParams();
  const [data, setData] = useState([]);
  const storedBranch = localStorage.getItem("branch");
  const [selectedBranch, setSelectedBranch] = useState(storedBranch || "");
  const navigate = useNavigate();
  const [header, setHeader] = useState({});
  const [cum, setCum] = useState({});
  const [loading, setLoading] = useState(false);

  const canView  = hasPermission("Vehicle Log Book", "view");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/log_book_get_veh_trans_own?vcode=${id}`
        );
        setData(response.data.vehTransData);
      } catch (error) {
        console.error("Error fetching vehTransData:", error);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchData();
    }
  }, [id]);

 
  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/get_veh_detail1_reportheader_api?vcode=${id}&branch=${branch}`
        );
        if (response.data && response.data.headerDetails?.length > 0) {
          const items = response.data.headerDetails;

          const storeReqHeader = {
            vehicle_type: items[0].vehicle_type || "N/A",
            vehicle_name: items[0].vehicle_name || "N/A",
            vehicle_code: items[0].vehicle_code || "N/A",
            vehicle_number: items[0].vehicle_number || "N/A",
          };

          setHeader(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchIndentDetails();
  }, [id, branch]);

  useEffect(() => {
    const fetchCumTot = async () => {
      try {
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/log_book_get_main_own?vcode=${id}`
        );
        if (response.data && response.data.cumulativeHrs?.length > 0) {
          const items = response.data.cumulativeHrs;

          const storeReqHeader = {
            total_hours: items[0].total_hours || "N/A",
            total_km: items[0].total_km || "N/A",
            vBasis: items[0].vehicle_basis || "N/A",
          };

          setCum(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchCumTot();
  }, [id]);

  // near top of the component
const [site, setSite] = useState({
  ok: true,
  name: "Infraconsoft",
  logo: null,
  address: "",
  email: "",
  phone: "",
  _ts: 0,
});

useEffect(() => {
  let ignore = false;
  (async () => {
    try {
      const res = await axios.get("https://rfs2.infraconsoft.net.in/api/siteinfo");
      const s = res?.data || {};
      let logo = s.logo || null;
      if (logo && !/^https?:\/\//i.test(logo)) {
        if (!logo.startsWith("/")) logo = `/${logo}`;
        logo = `${window.location.origin}${logo}`;
      }
      if (!ignore) {
        setSite({
          ok: !!s.ok,
          name: s.name || "Infraconsoft",
          logo,
          address: s.address || "",
          email: s.email || "",
          phone: s.phone || "",
          _ts: Date.now(),
        });
      }
    } catch (e) {
      console.error("Failed to load /siteinfo", e);
    }
  })();
  return () => { ignore = true; };
}, []);


  const exportToExcel = () => {
  // 1) Build rows as you already do
  const exportData = data.map((item, index) => ({
    "S.No": index + 1,
    "Vehicle Code": item.fld_vehiclecode,
    "From": item.fld_transfer_from,
    "To": item.fld_transfer_to,
    "Transfer By": item.fld_transfer_by,
    "Transferred Date": new Date(item.fld_transfer_time).toLocaleDateString("en-GB"),
    "Approved Date": new Date(item.fld_approved_time).toLocaleDateString("en-GB"),
    "Approved By": item.fld_approval_by,
  }));

  // 2) Preserve column order
  const headers = exportData.length
    ? Object.keys(exportData[0])
    : ["S.No","Vehicle Code","From","To","Transfer By","Transferred Date","Approved Date","Approved By"];

  // Convert to AOA
  const dataRows = exportData.map(r => headers.map(h => r[h] ?? ""));

  // 3) Company header + title
  const COLS = headers.length;
  const fullWidth = (text = "") => [text, ...Array(COLS - 1).fill("")];
  const title = "Vehicle Transfer History";

  const aoa = [
    fullWidth((site.name || "Infraconsoft").toUpperCase()),
    fullWidth(site.address || ""),
    fullWidth(
      [site.phone ? `Ph: ${site.phone}` : "", site.email ? `Email: ${site.email}` : ""]
        .filter(Boolean)
        .join(" | ")
    ),
    [], // spacer
    fullWidth(title),
    [], // spacer
    headers,
    ...dataRows,
  ];

  // 4) Worksheet with merges, widths, freeze
  const ws = XLSX.utils.aoa_to_sheet(aoa);

  ws["!merges"] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: COLS - 1 } }, // name
    { s: { r: 1, c: 0 }, e: { r: 1, c: COLS - 1 } }, // address
    { s: { r: 2, c: 0 }, e: { r: 2, c: COLS - 1 } }, // phone/email
    { s: { r: 4, c: 0 }, e: { r: 4, c: COLS - 1 } }, // title
  ];

  // sensible widths
  const widthMap = {
    "S.No": 6,
    "Vehicle Code": 16,
    "From": 18,
    "To": 18,
    "Transfer By": 20,
    "Transferred Date": 18,
    "Approved Date": 16,
    "Approved By": 18,
  };
  ws["!cols"] = headers.map(h => ({ wch: widthMap[h] || 16 }));

  // freeze after header block (6 rows before table header)
  ws["!freeze"] = { xSplit: 0, ySplit: 6, topLeftCell: "A7", activePane: "bottomLeft" };

  // 5) Workbook + save
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Vehicle Transfer History");

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });
  saveAs(blob, `veh_trans_history.xlsx`);
};


  if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          
            <div className="back-div">
                      <h2 className="add-txt">Vehicle Transferring - History</h2>
                      <Link to={`/vehicle_logbook_list`}><p className="back-button"><i className="fa-solid fa-backward"></i> Back</p></Link>
                      </div>
          <div>
            <Time />
          </div>
        </section>

        <div className="add-new-container">
          <button className="add-new-btn" onClick={exportToExcel}>
            <i className="fa-solid fa-file-excel"></i> Export to Excel
          </button>
        </div>
        <br></br>

        <div className="form-container">
          <form className="vehicle-form">
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Code :</label>
                <input
                  type="text"
                  name="vehicle_code"
                  value={header.vehicle_code}
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Vehicle Type :</label>
                <input
                  type="text"
                  name="vehicle_type"
                  value={header.vehicle_type}
                  readOnly
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Name :</label>
                <input
                  type="text"
                  name="vehicle_name"
                  value={header.vehicle_name}
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Vehicle Number :</label>
                <input
                  type="text"
                  name="vehicle_number"
                  value={header.vehicle_number}
                  readOnly
                />
              </div>
            </div>

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Vehicle Code</th>
                    <th>From</th>
                    <th>To</th>
                    <th>Transfer By</th>
                    <th>Transferred Date</th>
                    <th>Approved by</th>
                    <th>Approved Date</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="6" className="loading-text">
                        Loading data, please wait...
                      </td>
                    </tr>
                  ) : data.length > 0 ? (
                    data.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.fld_vehiclecode}</td>
                        <td>{item.fld_transfer_from}</td>
                        <td>{item.fld_transfer_to}</td>
                        <td>{item.fld_transfer_by}</td>
                        <td>{new Date(item.fld_transfer_time).toLocaleDateString()}</td>
                        <td>{new Date(item.fld_approved_time).toLocaleDateString()}</td>
                        <td>{item.fld_approval_by}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6">No Data Available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Vehicle_Transferring_history;
